import React from 'react'

const About = () => {
  return (
    <div className='container text-center'>
        <br/><br/>
        <h2>Quienes somos</h2>
        <br/><br/>
        <p>Bienvenido al mundo de la belleza y cuidado de la piel con nuestra empresa dedicada a la venta de cremas de alta calidad. Nos enfocamos en proporcionar soluciones de cuidado de la piel efectivas que ayuden a rejuvenecer la piel, frenar el deterioro de la piel, humectar la piel y eliminar impurezas.<br/><br/>

        Nuestras cremas de tipo skin care están formuladas con ingredientes naturales y no contienen sustancias dañinas para la piel o el medio ambiente. Nos enorgullece decir que nuestras cremas no son testeadas en animales, ya que nos esforzamos por ser una empresa responsable y ética.
        <br/><br/>
        Creemos que la belleza y el cuidado de la piel deben ser accesibles para todos, por lo que nuestras cremas son asequibles y están disponibles en diferentes formatos y tamaños para satisfacer las necesidades de nuestros clientes. Además, nuestras cremas son adecuadas para todo tipo de pieles y son capaces de proporcionar resultados notables en poco tiempo.
        <br/><br/>
        En resumen, si buscas productos de cuidado de la piel de calidad, que sean respetuosos con el medio ambiente y no sean testeados en animales, entonces nuestra empresa es la elección perfecta para ti. Contáctanos hoy mismo y permítenos ayudarte a lograr una piel radiante y saludable.</p>
        <br/><br/>
    </div>
  )
}

export default About